module.exports = __webpack_public_path__ + "img/video_cn.b2c1a09.jpg";